export enum TransactionCheckStatus {
  SEND = 'SEND',
  ACCEPT = 'ACCEPT',
  APPROVED = 'APPROVED',
  REJECT = 'REJECT',
  SUCCESS = 'SUCCESS',
  BOUNCED = 'BOUNCED',
}
